import React from 'react'
import { Link } from 'react-router-dom'
import New_1 from '../../../assets/images/home_page_2/collection/01.png'
import New_2 from '../../../assets/images/home_page_2/collection/02.png'
import New_3 from '../../../assets/images/home_page_2/collection/03.png'
import New_4 from '../../../assets/images/home_page_2/collection/04.png'


const NewCollection = () => {
    return (
        <>
            <section id="new-collection" className="new-collection-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <div className="new-collection-block">
                                <div className="new-collection-img">
                                    <img
                                        src={New_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="new-collection-dtls-block">
                                    <ul className="new-collection-discount-tag">
                                        <li className="upto cormorant-font">Up To</li>
                                        <li>
                                            <h1 className="discount-percentage cormorant-font">50%</h1>
                                        </li>
                                        <li className="discount cormorant-font">Discount</li>
                                    </ul>
                                    <Link to="#" title="" className="btn btn-primary-second">
                                        Shop Now <i className="flaticon-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="section">
                                <h2 className="section-title cormorant-font">New Collections</h2>
                                <p>
                                    which is the same as saying through shrinking from toil and pain.
                                    These cases are perfectly simple and easy to distinguish. In a free
                                    hour, when our power of choice is untrammelled and when nothing
                                    prevents our being able to do what we like best
                                </p>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-6">
                                    <div className="new-collection-product-block">
                                        <Link to="#" title="">
                                            <img
                                                src={New_2}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="new-collection-product-dtl">
                                            <h5 className="new-collection-product-title">
                                                <Link to="#" title="">
                                                    Mini Macaron Ceramic
                                                </Link>
                                            </h5>
                                            <p>$7.89</p>
                                            <Link to="#" title="" className="btn btn-secondary-second">
                                                Shop Now <i className="flaticon-arrow-right" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-6">
                                    <div className="new-collection-product-block">
                                        <Link to="#" title="">
                                            <img
                                                src={New_3}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="new-collection-product-dtl">
                                            <h5 className="new-collection-product-title">
                                                <Link to="#" title="">
                                                    Minimal Design Bottle
                                                </Link>
                                            </h5>
                                            <p>$7.89</p>
                                            <Link to="#" title="" className="btn btn-secondary-second">
                                                Shop Now <i className="flaticon-arrow-right" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-6">
                                    <div className="new-collection-product-block">
                                        <Link to="#" title="">
                                            <img
                                                src={New_4}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="new-collection-product-dtl">
                                            <h5 className="new-collection-product-title">
                                                <Link to="#" title="">
                                                    Jar Ripple Bottle
                                                </Link>
                                            </h5>
                                            <p>$7.89</p>
                                            <Link to="#" title="" className="btn btn-secondary-second">
                                                Shop Now <i className="flaticon-arrow-right" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default NewCollection
